// Web module: remediation approvals. Custom list and detail, not the generic entity pages.
// Admin and InfoSec Lead open a fix Compliancebot proposed and approve or reject it.
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { appRoute } from '../../app/route-base'
import type { WebModule } from '../../lib/modules'
import { canReadModule } from '../../lib/permissions'

export const remediationListRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/remediation',
  component: lazyRouteComponent(() => import('./RemediationListPage'), 'RemediationListPage'),
})

export const remediationDetailRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/remediation/$id',
  component: lazyRouteComponent(() => import('./RemediationDetailPage'), 'RemediationDetailPage'),
})

export const module: WebModule = {
  routes: [remediationListRoute, remediationDetailRoute],
  entityOverrides: {},
  nav: [
    {
      // Same key as the entity name, so this replaces the generic list entry once the schema ships it.
      key: 'remediation_action',
      label: 'Remediation',
      to: '/remediation',
      group: 'Settings',
      order: 42,
      icon: 'remediation',
      module: 'remediation',
      visible: (viewer) => canReadModule(viewer, 'remediation'),
    },
  ],
}
